import { FC, ReactNode, useContext } from 'react'
import s from './SectionCarouselItems.module.sass'
import { Carousel } from '@shared/ui/Layout/Carousel'
import { SectionCarouselContext, TypeCarouselState } from '@shared/ui/Layout/SectionCarousel/SectionCarouselContext'
import { KeenSliderInstance } from 'keen-slider/react'

interface Props {
  children: ReactNode[]
  onSlideChanged?: (data: KeenSliderInstance) => void
}

const SectionCarouselItems: FC<Props> = ({ children, onSlideChanged }): React.ReactElement | null => {
  const [context, _setContext] = useContext(SectionCarouselContext) as [
    TypeCarouselState,
    React.Dispatch<React.SetStateAction<TypeCarouselState>>,
  ]

  const handleSlideChanged = (data: KeenSliderInstance) => {
    onSlideChanged && onSlideChanged(data)
  }

  if (!context.skeleton) {
    return (
      <Carousel.Slider
        countSlidesOnContainer={context.countSlidesOnContainer as 2 | 6 | 3}
        className={s.slider}
        slideChanged={handleSlideChanged}>
        {children}
      </Carousel.Slider>
    )
  }

  return null
}

export default SectionCarouselItems
